const OSS = require("ali-oss");
import { getOssAccessApi } from "@/api/common";
import { Message } from "element-ui";
import store from "../store/index";
export default {
  //   /**
  //  * 阿里云oss sdk文件上传
  //   dir 上传到的文件位置
  //  * @param {*} file 文件流
  //  * @param {*} successCallback 成功回调
  //  * @param {*} errCallBack 失败回调
  //  * @param {*} progressCallBack 上传进度回调
  //  * @param {*} type 文件类型
  //  * @param {*} bucketName 阿里云桶名（可以指定多个桶名）
  //  * @param {*} dir 上传文件夹路径  譬如images
  //  */

  bucketUpload(
    file,
    successCallback = new Function(),
    errCallBack = new Function(),
    progressCallBack = new Function(),
    dir = "uploads",
    type = "image",
    bucketName = "oss-cn-beijing"
  ) {
    let fileName = file.name; // 先获取上传要的资料签名
    const { AccessKeyID, AccessKeySecret } = store.state.AccessKey;

    const getOssConfig = async () => {
      if (AccessKeyID && AccessKeySecret) {
        return {
          accessKeyId: AccessKeyID.replace(/B/g, ''),
          accessKeySecret: AccessKeySecret.replace(/B/g, ''),
        }
      }else{
        const res = await getOssAccessApi();
        if (res.status !== 200) {
          Message.error("获取oss配置失败");
          return;
        }
        return {
          accessKeyId: res.data.AccessKeyID.replace(/B/g, ''),
          accessKeySecret: res.data.AccessKeySecret.replace(/B/g, ''),
        }
      }
 
    }

    getOssConfig()
      .then((res) => {
          const client = new OSS({
            // 实例化一个上传客户端
            region: bucketName, // yourRegion填写Bucket所在地域。Region填写为oss-cn-hangzhou。我的存储是北京，可根据具体配置自行修改
            // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。）（后台接口返回）
            accessKeyId: res.accessKeyId,
            accessKeySecret: res.accessKeySecret,
            // 从STS服务获取的安全令牌（SecurityToken）。
            // stsToken: res.data.policy,
            // 填写Bucket名称。
            bucket: "dsjszkj",
            // endpoint: "oss-cn-beijing.aliyuncs.com",
          });


          const result = client.multipartUpload(
            (dir += "/" + Math.floor(Math.random() * 1000000) + Date.now() + fileName),
            file,
            {

              progress(p) {
                progressCallBack({
                  uid: file.uid,
                  name: fileName,
                  url: res.url,
                  size: file.size,
                  progress: p * 100,
                  type: type,
                });
              },
            }
          );
          result
            .then((res) => {
              successCallback({
                uid: file.uid,
                name: fileName,
                url: res.res.requestUrls[0].split("?")[0],
                size: file.size,
                progress: 100,
                type: type,
              });
            })
            .catch((err) => {
              console.log(err)
              errCallBack(err);
            });

      })
      .catch((err) => {
        Message.error({
          message: err.msg,
          showClose: true,
          type: "error",
        });
      });
  },
};
